export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((registration) => {
        console.log(
          "EDUJAC PWA service worker registered:",
          registration.scope
        );

        // Check periodically for a newer EDUJAC frontend.
        setInterval(() => {
          registration.update().catch(() => {});
        }, 60 * 60 * 1000);
      })
      .catch((error) => {
        console.error(
          "EDUJAC PWA service worker registration failed:",
          error
        );
      });
  });
}
